<template>
  <div class="mv-card" :class="{ 'is-sel': selected, 'is-cut': isCut }" :title="assetTooltip(asset)" :draggable="canEdit" @dragstart="onDragStart" @click="play()">
    <div style="position: relative; aspect-ratio: 16 / 9; background: var(--bg)">
      <v-img contain :src="$store.state.getThumbUrl(asset.id, asset.thumbnail)" style="position: absolute; inset: 0; width: 100%; height: 100%" />
      <span v-if="showsStatus" class="thumb-badge" :style="pillStyle(state.color)" :title="state.detail" style="top: 6px; left: 6px"
        ><span class="pill-dot"></span>{{ state.label }}</span
      >
      <span v-if="$store.state.isInActiveCart(asset.id)" class="thumb-check" title="In active cart">✓</span>
      <span v-if="durationTc" class="thumb-badge" style="bottom: 6px; right: 6px; padding: 0 6px; border-radius: 4px">{{ durationTc }}</span>
      <div class="mv-card-actions">
        <button
          type="button"
          class="mv-tile-btn"
          :class="{ 'is-on': whole }"
          :title="$store.state.cartToggleTitle(asset.id)"
          @click.stop="$store.state.toggleWholeAsset(asset)">
          {{ whole ? "✓" : "+" }}
        </button>
        <button type="button" class="mv-tile-btn mv-tile-btn--cut" title="Open in player to mark a clip" @click.stop="play()">✂</button>
      </div>
    </div>
    <div style="padding: 9px 10px 10px; display: flex; flex-direction: column; gap: 6px; min-width: 0">
      <div class="mv-card-title">{{ assetTitle(asset) }}</div>
      <div style="display: flex; flex-wrap: wrap; gap: 4px">
        <span v-for="tag in tags" :key="tag" class="tag-chip">{{ tag }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { assetState, showsStatus, pillStyle } from "@/scripts/assetStatus";
import { toTc } from "@/scripts/timecode.js";
import { whenVisible, stopWatching } from "@/scripts/media.js";
import { assetTitle, assetTooltip, assetTags } from "@/scripts/assetLabels.js";

export default {
  props: {
    asset: { type: Object, required: true },
  },
  data: () => {
    return {
      seen: false,
    };
  },
  computed: {
    selected() {
      return this.$store.state.currentClip.id === this.asset.id;
    },
    canEdit() {
      return this.$store.state.canEdit(this.asset);
    },
    isCut() {
      return this.$store.state.cutAssets.some((a) => a.id === this.asset.id);
    },
    /** The asset's whole-asset entry in the active cart, which + adds and ✓ removes. */
    whole() {
      return !!this.$store.state.wholeClipOf(this.asset.id);
    },
    state() {
      return assetState(this.asset);
    },
    showsStatus() {
      return showsStatus(this.asset);
    },
    durationTc() {
      const secs = this.$store.state.durationOf(this.asset.id);
      return secs ? toTc(secs) : "";
    },
    // A new status key (upload, processing, ready) asks again, so a tile that turns ready gets its length.
    probeKey() {
      return this.seen ? this.asset.id + ":" + this.state.key : "";
    },
    tags() {
      return assetTags(this.asset);
    },
  },
  methods: {
    assetTitle,
    assetTooltip,
    pillStyle,
    play() {
      this.$store.state.playClip(this.asset);
    },
    onDragStart(e) {
      e.dataTransfer.setData("assetID", this.asset.id);
      e.dataTransfer.effectAllowed = "move";
    },
  },
  watch: {
    probeKey(key) {
      if (key) this.$store.state.requestDuration(this.asset);
    },
  },
  // ponytail: seen stays true after the first sighting, so each status key is probed once.
  mounted() {
    whenVisible(this.$el, () => (this.seen = true));
  },
  beforeDestroy() {
    stopWatching(this.$el);
  },
};
</script>
